export class GcpPrincipalInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "user",
            "baseName": "user",
            "type": "string",
            "format": ""
        },
        {
            "name": "group",
            "baseName": "group",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpPrincipalInput.attributeTypeMap;
    }
    constructor() {
    }
}
